// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__10AsI","productName":"Table_productName__2z9le"};